// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3fWHt","range":"MonthRangeSwitch_range__1G1bh","disabled":"MonthRangeSwitch_disabled__q2RnL"};